import { Box, TextField } from '@mui/material';
import React from 'react';

type Props = {
  date: string | null;
  onDateChange: (date: string) => void;
  label?: string;
  minWidth?: number;
};

export const DateFilter = ({ date, onDateChange, label = "Wybierz datę", minWidth = 150 }: Props) => {
  return (
    <Box ml="auto" minWidth={minWidth}>
      <TextField
        size="small"
        type="date"
        fullWidth
        variant="outlined"
        label={label}
        value={date || ''}
        onChange={(e) => onDateChange(e.target.value)}
        InputLabelProps={{ shrink: true }}
      />
    </Box>
  );
};
